import React, { useContext } from "react";
import { AppContext } from "../../util/context";
import block from "bem-css-modules";
import styles from "./ProgressBar.module.scss";

const ProgressBar = () => {
  const context = useContext(AppContext);
  const { steps, activeStepIndex } = context;
  const { isSuccessPage } = steps[activeStepIndex];
  
  const b = block(styles);

  const progressPercentage = ((isSuccessPage ? (steps.length + 1) : (activeStepIndex + 1)) / (steps.length + 1)) * 100;

  return (
    <div className={`fc-progress-bar ${b()}`}>
      <div className={`fc-progress-bar-inner ${b("bar")}`}>
        <div
          className={`fc-progress-bar-progress ${b("progress")}`}
          style={{ width: `${progressPercentage}%` }}
          role="progressbar"
          aria-valuenow={activeStepIndex}
          aria-valuemin={1}
          aria-valuemax={steps.length}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
